import Image from '@components/Image'
import { Link } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

// import VisibilitySensor from 'react-visibility-sensor';
// import CountUp from 'react-countup';

const AboutUs1 = ({
  image_gatsby,
  title,
  subtitle,
  button,
  items,
}: RealEstateDataPageComponentData) => {
  return (
    <section className={'about-us a pt-5 mt-lg-0 mt-lg-0 position-relative'}>
      <div className="opacity"></div>
      <Image
        className="w-100 background-image-absolute no-border"
        objectFit="cover"
        alt="about-us-img"
        image={image_gatsby!}
      />
      <Container
        fluid
        className="py-lg-5"
      >
        <Row>
          <Col lg={2}>
            <p className="mt-lg-auto section-name">{title}</p>
          </Col>
          <Col lg={10}>
            <h2 className="sub-section">{subtitle}</h2>
          </Col>
          <Col
            xs={10}
            lg={{ offset: 2 }}
            className="mt-lg-5"
          >
            <Link
              to={'buttons[0].link'}
              className="btn btn-white"
            >
              {button?.value}
            </Link>
          </Col>
          <Col
            lg={{ span: 10, offset: 2 }}
            className={`pt-5 mt-5 ${items?.length === 0 ? 'd-none' : ''}`}
          >
            <Row className="py-lg-5">
              {items?.map((item, index) =>
                index > 1 && index % 2 === 0 ? (
                  <Col
                    lg={6}
                    key={index}
                    className={'pr-lg-4'}
                  >
                    <div className="item">
                      <Row className="no-gutters">
                        <Col
                          xs={6}
                          className="text-end"
                        >
                          <h1 className="hyper d-flex justify-content-end">
                            +
                            {/* <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
                                                        {({ isVisible }) => ( */}
                            <span className="counter-value one">
                              {/* {isVisible ? <CountUp end={item.value} /> : null} */}
                              {item.value}
                            </span>
                            {/* )}
                                                    </VisibilitySensor> */}
                          </h1>
                        </Col>
                        <Col
                          xs={6}
                          className="px-3"
                        >
                          <p>{item.paragraph}</p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ) : (
                  <Col
                    lg={6}
                    key={index}
                  >
                    <div
                      className="item"
                      id="counter"
                    >
                      <Row className="no-gutters">
                        <Col
                          xs={6}
                          lg={7}
                          className="text-end"
                        >
                          <h1 className="hyper d-flex justify-content-end">
                            +
                            <span className="counter-value one">
                              {/* {isVisible ? <CountUp end={item.value} /> : null} */}
                              {item.value}
                            </span>
                            {/* <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
                                                        {({ isVisible }) => ( */}
                            {/* //     )}
                                                    // </VisibilitySensor> */}
                          </h1>
                        </Col>
                        <Col className="col-6 col-lg-5 px-3">
                          <p>{item.paragraph}</p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ),
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs1
